export default {
  heading: {
    fontFamily: 'heading',
    fontWeight: 'heading',
    lineHeight: 'heading'
    // textTransform: 'capitalize',
  },
  text: {
    lineHeight: 'body',
    fontFamily: 'body',
    fontWeight: 'body',
    fontSize: '1rem',
    color: 'inherit'
  },
  navLink: {},
  link: {
    textDecoration: 'none',
    color: 'unset'
  }
}
